import { ReactNode, createContext, useEffect, useState } from "react";
import { emptyPurchaseOrder, IPurchaseOrder } from "../../../../types/purchaseOrder.types";
import { getPurchaseOrderById, updatePurchaseOrder } from "../../../../common/services/purchaseOrder.api";

type InitialStateType = {
  purchaseOrder: IPurchaseOrder
  savePurchaseOrder: (data: IPurchaseOrder) => Promise<{
    ok: boolean;
    data: IPurchaseOrder;
    errors: [{
      message: string;
      path: string[];
    }];
  }>
}

const initialState: InitialStateType = {
  purchaseOrder: emptyPurchaseOrder(),
  savePurchaseOrder: () => Promise.reject({
    ok: false,
    data: emptyPurchaseOrder(),
    errors: [{
      message: 'not-implemented',
      path: ['.']
    }]
  })
}

/* eslint-disable react-refresh/only-export-components */
export const PurchaseOrderDashboardContext = createContext(initialState);

type Props = {
  children: ReactNode,
  purchaseOrderId: string
}

export function PurchaseOrderDashboardProvider(props: Props) {

  const [purchaseOrder, setPurchaseOrder] = useState<IPurchaseOrder>(initialState.purchaseOrder);

  useEffect(() => {

    async function loadPurchaseOrder(id: string) {
      const result = await getPurchaseOrderById(id);
      if (result.ok) {
        setPurchaseOrder(result.data as IPurchaseOrder);
      }
    }
    loadPurchaseOrder(props.purchaseOrderId)

  }, [props.purchaseOrderId]);

  async function savePurchaseOrder(dataToSave: IPurchaseOrder) {
    try {
      const { ok, data, errors } = await updatePurchaseOrder(dataToSave);

      return { ok, data: data as IPurchaseOrder, errors: errors as [{ message: string, path: string[] }] };
    } catch (err) {
      console.log(err);
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }

  const theState = { purchaseOrder, savePurchaseOrder }
  return (
    <PurchaseOrderDashboardContext.Provider value={theState as InitialStateType}>
      {props.children}
    </PurchaseOrderDashboardContext.Provider>
  )
}